module.exports = __webpack_public_path__ + "static/media/[激动]@2x.1f7aef65.png";